import { MapPin, Monitor, Clock, ExternalLink } from "lucide-react";

function humanDuration(sec) {
  if (!sec || sec < 0) return "0s";
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return m ? `${m}m ${s}s` : `${s}s`;
}

function shortUA(ua = "") {
  if (/iPhone/i.test(ua)) return "iPhone";
  if (/iPad/i.test(ua)) return "iPad";
  if (/Android/i.test(ua)) return "Android";
  if (/Mac OS X/i.test(ua)) return "Mac";
  if (/Windows/i.test(ua)) return "Windows";
  if (/Linux/i.test(ua)) return "Linux";
  return "Other";
}

export default function SessionDetailModal({ detail, onClose }) {
  if (!detail) return null;
  const { session, pageviews, events, enquiry } = detail;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div className="bg-[hsl(var(--bg))] border border-[hsl(var(--line))] max-w-3xl w-full max-h-[85vh] overflow-y-auto p-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-6">
          <div className="kicker">Session detail</div>
          <button onClick={onClose} className="text-xs tracking-[0.3em] uppercase" data-testid="session-modal-close">Close</button>
        </div>
        <div className="font-display text-3xl md:text-4xl leading-tight">
          Score {session.score}{session.is_hot && <span className="ml-3 text-sm text-[hsl(var(--accent))] tracking-[0.3em] uppercase">HOT LEAD</span>}
        </div>
        <div className="mt-4 grid grid-cols-2 gap-3 text-sm text-[hsl(var(--ink-soft))]">
          <div className="flex items-center gap-2"><MapPin size={12} /> {session.city || "—"} {session.country ? `· ${session.country}` : ""}</div>
          <div className="flex items-center gap-2"><Monitor size={12} /> {shortUA(session.user_agent)}</div>
          <div className="flex items-center gap-2"><Clock size={12} /> {humanDuration(session.duration_seconds)} on site</div>
          <div className="flex items-center gap-2"><ExternalLink size={12} /> Referrer: {session.referrer || "(direct)"}</div>
        </div>

        <div className="mt-6 kicker">Journey ({pageviews.length} pages)</div>
        <ol className="mt-3 space-y-2 text-sm">
          {pageviews.map((p, i) => (
            <li key={`${p.timestamp}-${i}`} className="flex items-center justify-between">
              <span className="font-display text-base">{i + 1}. {p.path}</span>
              <span className="text-[hsl(var(--ink-soft))]">{new Date(p.timestamp).toLocaleTimeString()}</span>
            </li>
          ))}
        </ol>

        {events.length > 0 && (
          <>
            <div className="mt-6 kicker">Events</div>
            <ul className="mt-3 space-y-2 text-sm">
              {events.map((e, i) => (
                <li key={`${e.timestamp}-${i}`} className="flex items-center justify-between">
                  <span>{e.event_type}</span>
                  <span className="text-[hsl(var(--ink-soft))]">{new Date(e.timestamp).toLocaleTimeString()}</span>
                </li>
              ))}
            </ul>
          </>
        )}

        {enquiry && (
          <>
            <div className="mt-6 kicker">Enquiry submitted</div>
            <div className="mt-3 space-y-1 text-sm">
              <div><strong>{enquiry.name}</strong> — <a className="text-[hsl(var(--accent))] underline" href={`mailto:${enquiry.email}`}>{enquiry.email}</a></div>
              {enquiry.phone && <div>{enquiry.phone}</div>}
              {enquiry.event_type && <div>Event: {enquiry.event_type}</div>}
              {enquiry.message && <div className="mt-2 italic text-[hsl(var(--ink-soft))]">&ldquo;{enquiry.message}&rdquo;</div>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
